// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"96574f35","239":"77efb389","453":"4812d2b0","732":"bb88029f"}[chunkId] + ".chunk.js";
};